import cn from "classnames";
import { ContentView } from "components";
import styles from "./FlowsReportTabs.module.scss";
import { type ColumnOption } from "interfaces/columnOptions";
import { type FlowDetails } from "features/Reporting/types/content";
import {
  type PerformanceFilter,
  type PerformanceWithAccountFilter,
} from "features/Library/Common/utils/performanceUtils";
import { GenericPerformanceList } from "../../shared/GenericPerformanceList";
import FlowPrioritization from "features/Library/Flows/Performance/Tabs/FlowPrioritization";

export interface FlowsReportTabsProps {
  rows: FlowDetails[];
  columns: ColumnOption<FlowDetails>[];
  filter: PerformanceWithAccountFilter | PerformanceFilter;
  activeTab: number;
  includeAccounts: boolean;
  childAccountId?: number;
  setActiveTab: (tab: number) => void;
  hasCreateAccountsAddOn?: boolean;
}

export const FlowsReportTabs = ({
  rows,
  columns,
  filter,
  activeTab,
  setActiveTab,
  childAccountId,
  includeAccounts,
  hasCreateAccountsAddOn,
}: FlowsReportTabsProps) => {
  const tabs = [
    {
      label: "Flow Prioritization",
      component: (
        <FlowPrioritization
          dateFilter={filter}
          childAccountId={childAccountId}
          includeAccounts={includeAccounts}
          hasCreateAccountsAddOn={hasCreateAccountsAddOn}
        />
      ),
    },
    {
      label: "Flow Activity",
      component: <GenericPerformanceList title="Flows" rows={rows} columns={columns} filter={filter} />,
    },
  ];

  return (
    <div className={cn(styles.flowReportTabs, { noMax: activeTab > 0 })}>
      <ContentView
        activeIndex={activeTab}
        onTabChange={(_e, { activeIndex }) => setActiveTab(activeIndex)}
        tabs={tabs}
      />
    </div>
  );
};

export default FlowsReportTabs;
